import {type AnyElement, compute, create} from "@targoninc/jess";
import {PageInfo} from "../lib/pageInfo.ts";
import {currentPage, mobileMenuOpen} from "../lib/state.ts";

function toLink(page: PageInfo) {
    return `/${encodeURIComponent(page.filename)}`;
}

export function sidebarLink(page: PageInfo): AnyElement {
    const clean = page.filename.replaceAll("\\", "/");
    const isActive = compute(p => clean === p.replaceAll("\\", "/"), currentPage);
    const active = compute((a): string => a ? "active" : "_", isActive);

    const isGroupParent = page.children && page.children.length > 0;

    const hasActiveChild = compute(p => {
        const checkChildren = (children: PageInfo[]): boolean => {
            for (const child of children) {
                if (child.filename.replaceAll("\\", "/") === p.replaceAll("\\", "/")) return true;
                if (child.children && checkChildren(child.children)) return true;
            }
            return false;
        };
        return checkChildren(page.children);
    }, currentPage);

    const activeChildClass = compute((a): string => a ? "has-active-child" : "_", hasActiveChild);
    const groupParentClass = isGroupParent ? "group-parent" : "_";

    return create("div")
        .classes("flex-v", "no-gap")
        .children(
            create("a")
                .classes("sidebar-link", active, activeChildClass, groupParentClass)
                .text(page.title)
                .onclick((e: MouseEvent) => {
                    if (e.button === 0) {
                        currentPage.value = page.filename;
                        mobileMenuOpen.value = false;
                        e.preventDefault();
                    }
                })
                .href(toLink(page)),
            create("div")
                .classes("sidebar-link-children", "flex-v", "no-gap")
                .children(
                    ...page.children.map(child => sidebarLink(child))
                ).build()
        ).build();
}